// Import individual project modules
import { inverseePendulumController } from './projects/inverse-pendulum-controller';
import { neuralNetworkProgramming } from './projects/neural-network-programming';
import { manufacturingDataTransparencyApp } from './projects/manufacturing-data-transparency-app';
import { fieldQualityUseCase } from './projects/field-quality-use-case';
import { unityCatalogDataCatalog } from './projects/unity-catalog-data-catalog';
import { itGovernanceAndCompliance } from './projects/it-governance-and-compliance';
import { platformAiSuite } from './projects/platform-ai-suite';
import { lakehousePlatform } from './projects/lakehouse-platform';
import { platformStatisticsWebapp } from './projects/platform-statistics-webapp';
import { devopsAndDeploymentCoordination } from './projects/devops-and-deployment-coordination';
import { chatmate } from './projects/chatmate';

/**
 * IMPORTANT: GitHub Skills Integration Reminder
 * ============================================
 * 
 * When adding new projects with open source GitHub repositories:
 * 
 * 1. ADD GITHUB URL: Set the `git` field to the GitHub repository URL
 *    Example: git: "https://github.com/username/repo-name"
 * 
 * 2. LANGUAGE SKILLS AUTO-ENHANCEMENT: 
 *    - The system automatically fetches programming languages from GitHub API
 *    - Language skills in `categorizedSkills.language` will be replaced with GitHub data
 *    - This provides accurate language usage percentages from actual code analysis
 * 
 * 3. SKILL CALCULATION INTEGRATION:
 *    - Private projects: Uses `calculateGitHubEnhancedPrivateSkills()` 
 *    - Professional projects: Uses `calculateGitHubEnhancedProfessionalSkills()`
 *    - Portfolio page: Automatically includes GitHub-enhanced skills
 * 
 * 4. VERIFICATION:
 *    - Check that `isOpenSourceGitHubRepo()` returns true for your GitHub URL
 *    - Verify language skills are enhanced in the Portfolio > Private/Professional skills
 *    - Monitor console for any GitHub API errors during skill calculation
 * 
 * Files involved in GitHub integration:
 * - /lib/githubLanguages.ts - Core GitHub API integration
 * - /lib/privateSkillsUtils.ts - Private project GitHub enhancement
 * - /lib/githubEnhancedProfessionalSkills.ts - Professional project GitHub enhancement
 * - /hooks/useEnhancedProjectSkills.ts - Project detail page GitHub enhancement
 */

// Export all projects as an array
export const projectsData = [
  inverseePendulumController,
  neuralNetworkProgramming,
  manufacturingDataTransparencyApp,
  fieldQualityUseCase,
  unityCatalogDataCatalog,
  itGovernanceAndCompliance,
  platformAiSuite,
  lakehousePlatform,
  platformStatisticsWebapp,
  devopsAndDeploymentCoordination,
  chatmate
];
